export default {
  TUTTE: '0',
  IN_LAVORAZIONE: '1',
  SCARTATE: '2',
  DA_INVIARE: '3',
  TRASMESSE: '4',
  COMPLETE: '5',
  STAMPATE: '6',
  TRASMESSE_EPASA: '120',
  ACCETTATA_EPASA: '125',
  SCARTATA_EPASA: '130',
};
